export default __webpack_public_path__ + "static/media/shocked-face-with-exploding-head.5733d1c2.png";